export const NOTIFICATIONS = {
  SOMETHING_WENT_WRONG: "Something went wrong",
  BALANCE_UPDATED: "Balance added successfully",
  BALANCE_EXPIRED_DATE_UPDATED: "Balance expired date updated",
  FRIENDS_CODE_SHARING_UPDATED: "Invite friends code sharing updated",
  ACCESS_APP_INVITATION_UPDATED: "Invitation to access app updated",
  EXCHANGE_RATE_UPDATED: "Invitation to access app updated",
  BALANCE_EXPIRATION_DAYS_UPDATED: "Virtual currency expiration time updated",
  MIN_ORDER_COINS_UPDATED: "Minimum order (FM coins) updated",
  MIN_TOP_UP_UPDATED: "Minimum top up updated",
  TRIAL_PACKAGE_UPDATED: "Trial package successfully updated",
  PACKAGE_RULE_CREATED: "Rule successfully created",
  PACKAGE_RULE_UPDATED: "Rule successfully updated",
  PACKAGE_RULE_DELETED: "Rule successfully deleted",
  PACKAGE_CREATED: "Package successfully created",
  PACKAGE_UPDATED: "Package successfully updated",
  PACKAGE_DELETED: "Package successfully deleted",
  COIN_CONVERSION_UPDATED: "Coin conversion updated",
  ROLE_CREATED: "Role successfully added",
  ROLE_UPDATED: "Role successfully updated",
  ROLE_DELETE: "Role successfully deleted",
  USER_CREATE: "User successfully added",
  USER_UPDATE: "User successfully updated",
  USER_DELETE: "User successfully deleted",
  TRANSACTION_REFUND: "Balance has been successfully refunded",
};
